'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
    _inherits(ContactLink, _React$Component);

    function ContactLink(props) {
        _classCallCheck(this, ContactLink);

        return _possibleConstructorReturn(this, (ContactLink.__proto__ || Object.getPrototypeOf(ContactLink)).call(this, props));
    }

    _createClass(ContactLink, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.zEmbed || function (e, t) {
                var n,
                    o,
                    d,
                    i,
                    s,
                    a = [],
                    r = document.createElement('iframe');
                window.zEmbed = function () {
                    a.push(arguments);
                }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
                try {
                    o = s;
                } catch (c) {
                    n = document.domain, r.src = 'javascript:var d=document.open();d.domain=\"" + n + "\";void(0);', o = s;
                }
                o.open()._l = function () {
                    var o = this.createElement('script');
                    n && (this.domain = n), o.id = 'js-iframe-async', o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
                }, o.write('<body onload=\"document._l();\">'), o.close();
            }('https://assets.zendesk.com/embeddable_framework/main.js', 'hellosign.zendesk.com'); /*]]>*/
            zE(function () {
                zE.hide();
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            zE(function () {
                zE.activate({ hideOnClose: true });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var contactText = this.props.contactText || 'Contact';
            return _react2['default'].createElement(
                'a',
                { href: 'javascript:;', onClick: function onClick() {
                        return _this2.handleClick();
                    } },
                contactText
            );
        }
    }]);

    return ContactLink;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/contact-link.jsx
 ** module id = 1535
 ** module chunks = 0
 **/